import styled from 'styled-components';
import { prefix } from '../../tools/settings';
import { rem } from 'polished';
import Icon from '../Icon';
import Chip from '../Chip';
export var StyledTabs = styled.div.attrs({
  className: "".concat(prefix, "-tabs")
}).withConfig({
  displayName: "Tabsstyles__StyledTabs",
  componentId: "sc-tv9pf0-0"
})(["&.", "-tabs--bottom{display:flex;flex-direction:column-reverse;.", "-tabs__tab-list{margin-top:28px;margin-bottom:0;&:after{top:1px;bottom:auto;}}.", "-tabs__tab--list-tabs-action{padding:", " 0 0 ", ";&:before{bottom:", ";top:", ";}}.", "-tabs__tab{padding:", " 0 0;&::after{top:1px;bottom:auto;}&[aria-selected='true']{&::after{top:0;bottom:auto;}}}}"], prefix, prefix, prefix, rem(16), rem(8), rem(4), rem(20), prefix, rem(16));
export var StyledTab = styled.button.attrs({
  className: "".concat(prefix, "-tabs__tab")
}).withConfig({
  displayName: "Tabsstyles__StyledTab",
  componentId: "sc-tv9pf0-1"
})(["background:transparent;display:flex;color:var(--dentsu-color-n700);font-size:var(--dentsu-font-size-14);justify-content:flex-start;align-items:center;line-height:1;padding:0 0 ", ";border:none;position:relative;white-space:nowrap;span{text-align:left;}.dentsu-icon{color:var(--dentsu-color-n600);}small{font-size:var(--dentsu-font-size-12);font-weight:var(--dentsu-font-weight-light);}em{display:block;margin-top:4px;font-size:var(--dentsu-font-size-12);color:var(--dentsu-color-n700);padding-left:", ";}&::after{content:'';position:absolute;width:100%;height:1px;bottom:1px;left:0;background:var(--dentsu-color-fuchsia);border-radius:3px;opacity:0;transition:all var(--dentsu-motion-duration-moderate) var(--dentsu-motion-easing-standard);}&:focus{outline:none;}&:disabled{opacity:var(--dentsu-opacity-40);}&:hover:not(:disabled),&:focus{&::after{opacity:1;}}&[aria-selected='true']{font-weight:var(--dentsu-font-weight-medium);color:var(--dentsu-color-black);em{font-weight:var(--dentsu-font-weight-regular);color:var(--dentsu-color-black);}span{position:relative;}.dentsu-icon{color:var(--dentsu-color-n800);}&::after{opacity:1;height:3px;bottom:0;}}"], rem(16), function (props) {
  return props.icon ? rem(22) : 0;
});
export var StyledTabList = styled.div.attrs({
  className: "".concat(prefix, "-tabs__tab-list")
}).withConfig({
  displayName: "Tabsstyles__StyledTabList",
  componentId: "sc-tv9pf0-2"
})(["display:flex;position:relative;justify-content:space-between;margin-bottom:", ";.", "-tabs__tab{margin-right:", ";&:last-of-type{margin-right:0;}}&:after{content:'';height:1px;position:absolute;background:var(--dentsu-color-n300);left:0;right:0;bottom:1px;z-index:0;}&.", "-tabs__tab-list--right{justify-content:flex-end;}"], rem(28), prefix, function (props) {
  return props.spacing === 'narrow' ? rem(20) : rem(40);
}, prefix);
export var StyledTabListExtra = styled.div.attrs({
  className: "".concat(prefix, "-tabs__tab-list-extra")
}).withConfig({
  displayName: "Tabsstyles__StyledTabListExtra",
  componentId: "sc-tv9pf0-3"
})(["transform:translateY(-25%);"]);
export var StyledTabListTabs = styled.div.attrs({
  className: "".concat(prefix, "-tabs__tab-list-tabs")
}).withConfig({
  displayName: "Tabsstyles__StyledTabListTabs",
  componentId: "sc-tv9pf0-4"
})(["display:flex;flex-grow:1;overflow-x:auto;overflow-y:none;position:relative;z-index:1;"]);
export var StyledTabListTabsContainer = styled.div.attrs({
  className: "".concat(prefix, "-tabs__tab-list-tabs-container")
}).withConfig({
  displayName: "Tabsstyles__StyledTabListTabsContainer",
  componentId: "sc-tv9pf0-5"
})(["display:flex;flex-wrap:nowrap;"]);
export var StyledTabListTabsAction = styled.div.attrs({
  className: "".concat(prefix, "-tabs__tab--list-tabs-action")
}).withConfig({
  displayName: "Tabsstyles__StyledTabListTabsAction",
  componentId: "sc-tv9pf0-6"
})(["padding:0 0 ", " ", ";margin-left:", ";position:relative;&:before{content:'';width:1px;position:absolute;top:4px;left:0;bottom:20px;background:var(--dentsu-color-n300);}"], rem(16), rem(8), rem(16));
export var StyledTabPanels = styled.div.attrs({
  className: "".concat(prefix, "-tabs__tab-panels")
}).withConfig({
  displayName: "Tabsstyles__StyledTabPanels",
  componentId: "sc-tv9pf0-7"
})([""]);
export var StyledTabPanel = styled.div.attrs({
  className: "".concat(prefix, "-tabs__tab-panel")
}).withConfig({
  displayName: "Tabsstyles__StyledTabPanel",
  componentId: "sc-tv9pf0-8"
})(["outline:none;"]);
export var StyledTabActions = styled.div.attrs({
  className: "".concat(prefix, "-tabs__tab-actions")
}).withConfig({
  displayName: "Tabsstyles__StyledTabActions",
  componentId: "sc-tv9pf0-9"
})(["margin-left:8px;margin-right:-8px;margin-bottom:-12px;margin-top:-12px;"]);
export var StyledTabStatus = styled(Chip).withConfig({
  displayName: "Tabsstyles__StyledTabStatus",
  componentId: "sc-tv9pf0-10"
})(["margin:0 0 0 8px;"]);
export var StyledTabIcon = styled(Icon).attrs({
  className: "".concat(prefix, "-tabs__tab-icon")
}).withConfig({
  displayName: "Tabsstyles__StyledTabIcon",
  componentId: "sc-tv9pf0-11"
})(["margin-right:8px;position:relative;top:-1px;"]);